import toast from "react-hot-toast";
import apiPath from "../../../../config/apiPaths.json";
import {
  apiRequest,
  catchErrorMessageHandler,
  getUserName,
} from "../../../../infrastructure/backendService";
import ErrorPopup from "../../../common/ErrorPopup";
import constants from "../../../../config/constants.json";
import { useEffect, useState } from "react";
import { Box, Checkbox, Typography } from "@mui/material";
import styles from "./DevoteePoojaHallCart.module.scss";
import {
  CommonButton,
  CommonOutlinedButton,
  formatAmount,
} from "../../../common/StyledComponents/StyledFields";
import APILoading from "../../../common/APILoading/APILoading";
import { useLocation, useNavigate } from "react-router-dom";
import DevoteeModeOfPayment from "../../../common/modeOfPayment/devoteeModeOfPayment";
import { RoutingURLs } from "../../../common/RoutingURLs";

const DevoteePoojaHallCart = () => {
  const navigate = useNavigate();
  const { state } = useLocation();

  const [poojaHallBookedList, setBookedPoojaHallList] = useState<any[]>([]);
  const [APIfetched, setAPIFetched] = useState(false);
  const [totalAmount, setTotalAmount] = useState(0);
  const [selectedItems, setSelectedItems] = useState<any[]>([state?.id]);
  const [selectedItemstotal, setSelectedItemsTotal] = useState(0);
  const [buttonDisable, setButtonDisable] = useState(true);
  const [selectAllItems, setSelectAllItems] = useState(false);

  const getPoojaHallListApi = () => {
    apiRequest({
      method: "GET",
      endpoint: apiPath.bookedPoojaListApi,
      params: {
        sortBy: "id",
        page: 0,
        size: 500,
        direction: "asc",
        username: getUserName(),
      },
      includeToken: true,
    })
      .then((res) => {
        const data = res?.data?.content ?? [];
        const pendingPaymentsList = data?.filter(
          (each: any) =>
            each?.status === constants.POOJA_BOOKING_STATUS.CONFIRMED
        );
        setBookedPoojaHallList(pendingPaymentsList);
        let totalItemsAmount = 0;
        pendingPaymentsList?.forEach((each: any) => {
          totalItemsAmount += each?.amount;
        });
        setTotalAmount(totalItemsAmount);
        setAPIFetched(true);
      })
      .catch((err) => {
        setAPIFetched(true);
        toast.custom(
          <ErrorPopup showMessage={catchErrorMessageHandler(err)} />,
          {
            duration: constants.TOAST_POPUP_DURATION,
          }
        );
      });
  };

  useEffect(() => {
    window.scroll({ top: 340, left: 0, behavior: "smooth" });
    getPoojaHallListApi();
  }, []);

  useEffect(() => {
    let totalAmountOfSelectedItems = 0;
    poojaHallBookedList?.forEach((each) => {
      if (selectedItems?.includes(each?.id)) {
        totalAmountOfSelectedItems += each?.amount;
      }
    });
    setSelectedItemsTotal(totalAmountOfSelectedItems);
  }, [selectedItems, poojaHallBookedList]);

  const handleSelectItem = (id: any) => {
    let selectedIds = [...selectedItems];
    if (selectedItems?.includes(id)) {
      selectedIds = selectedItems.filter((item: string) => item !== id);
      setSelectedItems(selectedIds);
      setSelectAllItems(false);
    } else {
      selectedIds = [...selectedIds, id];
      setSelectedItems(selectedIds);
    }
  };

  const handleSelectAllItems = () => {
    setSelectAllItems(!selectAllItems);
    if (selectAllItems) {
      setSelectedItems([]);
      setButtonDisable(true);
    } else {
      let itemIds: any = [];
      poojaHallBookedList?.forEach((each: any) => {
        itemIds = [...itemIds, each?.id];
      });
      setSelectedItems([...itemIds]);
    }
  };

  const handleProceed = () => {
    const items = [...selectedItems?.map((id: any) => ({ itemId: id }))];
    sessionStorage.setItem("cartItems", JSON.stringify(items));
    navigate(
      `${RoutingURLs.creditPayment}?amount=${selectedItemstotal}&donationType=PE&status=undefined`
    );
  };

  const renderCart = () => {
    return (
      <Box sx={{ mt: "10px", overflowX: "auto" }}>
        <table className={styles.table_container}>
          <thead>
            <tr className={styles.headerTableRow}>
              <th style={{ width: "70px" }}>
                <Box display={"flex"} justifyContent={"center"}>
                  <Checkbox
                    checked={selectAllItems}
                    onChange={() => handleSelectAllItems()}
                    name={"allItems"}
                    sx={{
                      p: "0px",
                      color: "#F05802 !important",
                    }}
                  />
                </Box>
              </th>
              <th>Type</th>
              <th>Pooja Name</th>
              <th>Priest/Hall Name</th>
              <th>Location</th>
              <th>Date of Pooja</th>
              <th>Duration</th>
              <th style={{ textAlign: "right" }}>Amount</th>
            </tr>
          </thead>
          <tbody className={styles.tableBody} id="cartItemsList">
            {poojaHallBookedList.map((item: any, index: number) => (
              <tr key={index} className={styles.tableRow}>
                <td>
                  <Box display={"flex"} justifyContent={"center"}>
                    <Checkbox
                      checked={selectedItems?.includes(item?.id)}
                      onChange={() => handleSelectItem(item.id)}
                      name={"allFiles"}
                      sx={{
                        p: "0px",
                        color: "#F05802 !important",
                      }}
                    />
                  </Box>
                </td>
                <td>{item?.hallBooking ? "Event Hall" : "Pooja"}</td>
                <td>{item.poojaName}</td>
                <td>{item.priestHallName}</td>
                <td>{item.location ?? "Temple"}</td>
                <td>{item?.bookingDate}</td>
                <td>{item?.timeRequired} mins</td>
                <td style={{ textAlign: "right" }}>
                  {formatAmount(item?.amount)}
                </td>
              </tr>
            ))}
            {poojaHallBookedList.length > 0 && (
              <tr className={styles.table_row_background}>
                <td colSpan={7} className={styles.amount_text}>
                  Total
                </td>
                <td colSpan={1} className={styles.amount_text}>
                  {formatAmount(totalAmount)}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </Box>
    );
  };

  const renderPayments = () => {
    return (
      <>
        <DevoteeModeOfPayment
          setButtonDisable={setButtonDisable}
          amount={selectedItemstotal}
          donationPurpose={"H"}
          itemsList={selectedItems}
        />
      </>
    );
  };

  const renderButtonsComponent = () => {
    return (
      <Box sx={{ mt: "20px" }}>
        <CommonOutlinedButton onClick={() => navigate(-1)} sx={{ mr: "15px" }}>
          Cancel
        </CommonOutlinedButton>
        {selectedItems?.length > 0 && !buttonDisable && (
          <CommonButton disabled={buttonDisable} onClick={handleProceed}>
            Proceed
          </CommonButton>
        )}
      </Box>
    );
  };

  const render = () => {
    return (
      <>
        {poojaHallBookedList?.length > 0 ? (
          <>
            {renderCart()}
            {selectedItems?.length > 0 && renderPayments()}
          </>
        ) : (
          <Typography
            sx={{ mt: "15px", color: "red !important" }}
            className={"sub_heading"}
          >
            No pending requests found
          </Typography>
        )}
        {renderButtonsComponent()}
      </>
    );
  };

  return (
    <>
      <Typography className="main_heading">
        Booked Pooja/Hall Requests
      </Typography>
      {APIfetched ? render() : <APILoading />}
    </>
  );
};

export default DevoteePoojaHallCart;
